import styled from 'styled-components'

export const ContractTerms = styled.div`
  button {
    display: contents;
    font-size: 0.75rem;
    line-height: 0.9375rem;
  }
`
